export default __webpack_public_path__ + "static/media/image2.862eabe2.png";